import secureLocalStorage from 'react-secure-storage';

export default function handleErrors(errors) {
  if (errors.graphQLErrors) {
    errors.graphQLErrors.forEach((e) => {
      console.warn(
        `[GraphQL error]: Message: ${e.message}, \nLocation: ${e.locations}, \nPath: ${
          e.path
        }, \ndetails: ${JSON.stringify(e.extensions)}`
      );
      if (e.message === 'TokenValidationError') {
        console.log('Backend session expired. Redirecting to login...');
        localStorage.removeItem('admin-info');
        secureLocalStorage.removeItem('token');
        window.location.href = '/login';
      }
    });
  }
  if (errors.networkError) {
    console.warn(`[Network error]: ${errors.networkError}`);
  }
}
